import React from 'react';
import type { ButtonProps } from 'antd';
import { LockOutlined, UnlockOutlined } from '@ant-design/icons';
import * as S from './styles';

type ConsolidationButtonProps = ButtonProps & {
	onClick?: () => void;
	children?: React.ReactNode;
	showIcon?: boolean;
	freeze?: boolean;
};

export function ConsolidationButton({
	children = '',
	onClick,
	showIcon = true,
	freeze = false,
	...props
}: Readonly<ConsolidationButtonProps>) {
	return (
		<S.ConsolidationButton
			{...props}
			$freeze={freeze}
			onClick={onClick}
			icon={
				showIcon &&
				(freeze ? (
					<UnlockOutlined style={{ color: '#828282' }} />
				) : (
					<LockOutlined style={{ color: '#17A93B' }} />
				))
			}
		>
			{children}
		</S.ConsolidationButton>
	);
}
